var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1156_11917",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1156_11917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 29.3332V5.33317C2.66699 4.59984 2.9281 3.97206 3.45033 3.44984C3.97255 2.92762 4.60033 2.6665 5.33366 2.6665H26.667C27.4003 2.6665 28.0281 2.92762 28.5503 3.44984C29.0725 3.97206 29.3337 4.59984 29.3337 5.33317V21.3332C29.3337 22.0665 29.0725 22.6943 28.5503 23.2165C28.0281 23.7387 27.4003 23.9998 26.667 23.9998H8.00033L2.66699 29.3332ZM16.0003 19.9998C16.3781 19.9998 16.6948 19.8721 16.9503 19.6165C17.2059 19.3609 17.3337 19.0443 17.3337 18.6665C17.3337 18.2887 17.2059 17.9721 16.9503 17.7165C16.6948 17.4609 16.3781 17.3332 16.0003 17.3332C15.6225 17.3332 15.3059 17.4609 15.0503 17.7165C14.7948 17.9721 14.667 18.2887 14.667 18.6665C14.667 19.0443 14.7948 19.3609 15.0503 19.6165C15.3059 19.8721 15.6225 19.9998 16.0003 19.9998ZM14.667 14.6665H17.3337V6.6665H14.667V14.6665Z",
    fill: "#F29D1D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.72bb2b6b10ca3fa882142763b0850e60.svg";
export { ForwardRef as ReactComponent };